import { createEpic } from "../helpers";

import { getContactsListAsyncAction } from "./contactsActions";

export const getContactsListEpic = createEpic(
	getContactsListAsyncAction,
	"contacts",
	"getContactsList",
	true
);
